import { h } from "preact";
import { observer } from "mobx-react";
function FieldLabel(props) {
    const { htmlFor, isRequired, isHidden = false, children } = props;
    return (h("label", { class: `control-label m-form__label ${isRequired ? "m-form__label--required" : ""} ${isHidden ? "hidden" : ""}`, htmlFor: htmlFor }, children));
}
export default observer(FieldLabel);
